import React, { useEffect, useState } from "react";
import { getSettingsCompanyForOtherUsers, savePermissions } from "../../store/actions/permissions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Toggle } from "@ts-digital/vrc";
import {
  FEATURE_TOGGLE_IMPOSTE,
  FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS,
  FEATURE_TOGGLE_INCASSA_SUBITO,
  FEATURE_TOGGLE_ITEM_ACTIVITIES,
  FEATURE_TOGGLE_CLIENT_CARD,
  FEATURE_TOGGLE_CLIENT_CARD_SECTION,
  FEATURE_TOGGLE_DEADLINES_ACTIVITIES,
} from "../../config";
import { Collapse } from "antd";
import "./style.css";
import UserSettingsButtons from "./user-settings-buttons";
import useCompanyUserPermissionsList from "./useCompanyUserPermissionsList";
import useManagerUserPermissionsList from "./useManagerUserPermissionsList";
import BusinessPerformanceModal from "../header/businessPerformanceModal";
import { notification } from "antd";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";
const { Panel } = Collapse;

const excludedSpanishPermissions = [
  "3", // Via Mail
  "16", // Invio Automatico XML
  "19", // Autorizzare pagamenti e scadenze
  "107", // Autorizza scadenze fiscali e previdenziali
  "108", // Autorizza disposizioni di pagamento
  "20", // Vede scadenze create da fatture
  "78", // Scadenze
  "106", // Checkup Impresa
  "62", // Incassa subito
];

const UserSettings = ({
  auth,
  companySelected,
  companyUuidSelected,
  userUuidSelected,
  accountantUuidSelected,
  clientIdSelected,
  setOpenUsersDrawer,
  openUsersDrawer,
  managerUsers,
  itemUsers,
  setIsManager,
  ragioneSocialeAzienda,
  userCompleteName,
}) => {
  const dispatch = useDispatch();
  const currentPermissions = useSelector((state) => state.currentPermissions);
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);
  const [settings, setSettings] = useState([]);
  const [settingsToSave, setSettingsToSave] = useState([]);
  const [changeInSettings, setChangeInSettings] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [studioPermissions, setStudioPermissions] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [isItemUser, setIsItemUser] = useState(false);
  const [isManagerUser, setIsManagerUser] = useState(false);
  const [isBusinessPerformanceModalOpen, setIsBusinessPerformanceModalOpen] = useState(false);

  const studioFind = GetSelectedCompanyStudio();

  useEffect(() => {
    dispatch(getSettingsCompanyForOtherUsers(companyUuidSelected, userUuidSelected, accountantUuidSelected));
  }, [companyUuidSelected, userUuidSelected, accountantUuidSelected]);

  useEffect(() => {
    setStudioPermissions(currentPermissions.permissionClient.permissions);
    setUserPermissions(currentPermissions.permissionOtherUsers.otherUsersPermissions);
  }, [currentPermissions]);

  useEffect(() => setSettings(currentPermissions.permissionOtherUsers.otherUsersPermissions), [currentPermissions]);
  useEffect(() => setIsLoading(currentPermissions.isLoadingOtherUsersSettings ? true : false), [currentPermissions.isLoadingOtherUsersSettings]);

  useEffect(() => {
    const checkItemUser = itemUsers.some((user) => user.id === userUuidSelected);
    const checkManagerUser = managerUsers.some((user) => user.id === userUuidSelected);
    if (checkItemUser) {
      setIsItemUser(true);
      setIsManager(false);
    }
    if (checkManagerUser) {
      setIsManagerUser(true);
      setIsManager(true);
    }
  }, [itemUsers, managerUsers]);

  const openSuccessWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
      duration: 8,
      style: { marginTop: "50px" },
    });
  };

  const checkPermissionSaved = () => {
    if (!currentPermissions.isPermissionsSaving && !currentPermissions.isPermissionsError) {
      openSuccessWithIcon(
        "success",
        user?.profile?.language === "es-ES" ? "Configuración guardada correctamente" : "Impostazioni salvate correttamente",
        user?.profile?.language === "es-ES" ? "La configuración se ha guardado correctamente." : "Le impostazioni sono state salvate correttamente."
      );
    }
    if (currentPermissions.isPermissionsError) {
      openSuccessWithIcon(
        "error",
        user?.profile?.language === "es-ES" ? "Ha ocurrido un problema" : "Si è verificato un problema",
        user?.profile?.language === "es-ES" ? "La configuración no se ha guardado correctamente" : "Le impostazioni non sono state salvate correttamente."
      );
    }
  };

  const saveUserPermissions = () => {
    dispatch(savePermissions(settingsToSave, companyUuidSelected))
      .then((res) => {
        dispatch(getSettingsCompanyForOtherUsers(companyUuidSelected, userUuidSelected, accountantUuidSelected));
        checkPermissionSaved();
        setOpenUsersDrawer(!openUsersDrawer);
        setChangeInSettings(false);
      })
      .catch((err) => {
        dispatch(getSettingsCompanyForOtherUsers(companyUuidSelected, userUuidSelected, accountantUuidSelected));
        setOpenUsersDrawer(!openUsersDrawer);
        checkPermissionSaved();
        setChangeInSettings(false);
      });
  };

  const resetUserPermissions = async () => {
    setChangeInSettings(false);
    dispatch(getSettingsCompanyForOtherUsers(companyUuidSelected, userUuidSelected, accountantUuidSelected));
  };

  const businessPerformanceModalHandler = () => {
    setIsBusinessPerformanceModalOpen(true);
  };

  const onCloseBusinessPerformanceModal = () => {
    setIsBusinessPerformanceModalOpen(false);
  };

  const changeToggle = (indexGroup, indexFunction, functionName, value, isBusinessPerformance) => {
    value = isBusinessPerformance ? value : !value;

    let arraySettingsToSave = [];
    let currentSettings = settingsToSave.find((client) => {
      return client?.permissions?.[0]?.itemId === companyUuidSelected;
    });

    if (!currentSettings) {
      currentSettings = {
        ownerId: accountantUuidSelected ? accountantUuidSelected : "",
        userId: userUuidSelected,
        permissions: [
          {
            itemId: companyUuidSelected,
            userId: userUuidSelected ? userUuidSelected : null,
            actions: [],
          },
        ],
      };
    }

    currentSettings.permissions[0].actions.push({
      name: functionName,
      isActive: value ? true : false,
    });
    currentSettings.permissions[0].actions = [
      ...currentSettings?.permissions?.[0].actions.reverse().filter((action, index, self) => index === self.findIndex((a) => a.name === action.name)),
    ];

    arraySettingsToSave.push(currentSettings);

    let arraySettings = settings;

    arraySettings[indexGroup].permissions[indexFunction].isActive = value ? true : false;

    setSettings(arraySettings);
    setSettingsToSave(arraySettingsToSave);
    setChangeInSettings(true);
  };

  const studioPermissionsToIterate = studioPermissions?.map((perm) => perm.permissions);

  let color;
  let disabled;
  let findedCompany = company.companies.find((el) => {
    return el.id === clientIdSelected;
  });

  let collapsePanels = [];

  if (userPermissions && settings.length > 0 && !currentPermissions.isLoadingOtherUsersSettings) {
    let permissionsGroup = settings;
    const permissionsListStructure = isItemUser
      ? useCompanyUserPermissionsList(permissionsGroup, studioPermissionsToIterate)
      : useManagerUserPermissionsList(permissionsGroup, studioPermissionsToIterate);
    const permissionsListTemplate = permissionsListStructure?.map((str) => {
      return str?.listToIterate?.map((perm, index) => {
        if (str.listLabel === "permissionsList1" && isManagerUser) {
          if (FEATURE_TOGGLE_CLIENT_CARD_SECTION !== "true") {
            return null;
          }
        }
        if (str.listLabel === "permissionsList1") {
          if (perm.functionId === "21") {
            color = perm.isActive === true ? "#00c3ea" : "#9da6ad";
            disabled = perm.isActive === true ? false : true;
          }
          if (FEATURE_TOGGLE_IMPOSTE !== "true" && perm.functionId === "6") {
            return null;
          }
          if (FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && perm.functionId === "21") {
            return null;
          }
          if (FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && findedCompany && findedCompany.classifier === "PERSON" && perm.functionId === "21") {
            return null;
          }
          if (FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && perm.functionId === "77") {
            return null;
          }
          if (FEATURE_TOGGLE_INCASSA_SUBITO !== "true" && perm.functionId === "62") {
            return null;
          }
          if (FEATURE_TOGGLE_INCASSA_SUBITO === "true" && findedCompany && findedCompany.classifier === "PERSON" && perm.functionId === "62") {
            return null;
          }
        }
        if (str.listLabel === "permissionsList3") {
          if (perm.functionId === "17") {
            return null;
          }
        }
        if (str.listLabel === "permissionsList4") {
          if (FEATURE_TOGGLE_ITEM_ACTIVITIES !== "true" && perm.functionId === "19") {
            return null;
          }
          if (FEATURE_TOGGLE_DEADLINES_ACTIVITIES !== "true" && perm.functionId === "20") {
            return null;
          }
        }
        if (str.listLabel === "permissionsList5") {
          if (FEATURE_TOGGLE_CLIENT_CARD !== "true" && perm.functionId === "79") {
            return null;
          }
        }

        if (studioFind?.taxRegion === "ES" && excludedSpanishPermissions.indexOf(perm?.functionId) > -1) {
          return null;
        }
        return (
          <div key={index}>
            <div
              style={{
                display: perm.functionId === "21" && "flex",
                alignItems: perm.functionId === "21" && "center",
                height: "24px",
                marginBottom: perm.functionId === "77" || perm.functionId === "86" ? "20px" : "10px",
              }}
            >
              <div
                style={{
                  paddingRight: "20px",
                  display: "inline-block",
                  color: perm.companyPermission === false ? "rgb(157, 166, 173)" : "#000000",
                  fontWeight: "400",
                  width: "260px",
                  paddingLeft:
                    str.listLabel === "permissionsList1" || str.listLabel === "permissionsList2" || str.listLabel === "permissionsList5" ? "20px" : "0",
                }}
              >
                {user?.profile?.language === "es-ES" ? (
                  <FormattedMessage id={"permissions." + perm.functionLabel} defaultMessage={perm.functionLabel} />
                ) : (
                  perm.functionLabel
                )}
              </div>
              {str.listLabel === "permissionsList1" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && perm.functionId === "21" && (
                <div style={{ paddingRight: "37px" }}>
                  <button className="managerBpButton" style={{ color: color }} onClick={() => businessPerformanceModalHandler()} disabled={disabled}>
                    <FormattedMessage id="settings.manageBusinessPerformanceSettings" />
                  </button>
                </div>
              )}
              <div style={{ float: "right" }}>
                <Toggle
                  onChange={() => changeToggle(str.index, index, perm.functionName, perm.isActive)}
                  checked={perm.isActive === true ? true : false}
                  backgroundStandardColor={"#c9d9e8"}
                  disabled={perm.companyPermission === false}
                />
              </div>
            </div>
          </div>
        );
      });
    });

    const collapsePanelsStructure = [
      {
        header: <FormattedMessage id="settings.userPermissions.canSeeTitle" />,
        isMultipleGroup: true,
        subHeaders: isItemUser
          ? ["Nella sua home", "Nel suo menu", "Nei suoi documenti"]
          : isManagerUser && FEATURE_TOGGLE_CLIENT_CARD_SECTION !== "true"
          ? ["Nel suo menu", "Nei documenti del cliente"]
          : ["Nel suo menu", "Nella scheda cliente", "Nei documenti del cliente"],
        templates: [permissionsListTemplate?.[0], permissionsListTemplate?.[1], permissionsListTemplate?.[2]],
      },
      {
        header: <FormattedMessage id="settings.userPermissions.canUploadTitle" />,
        isMultipleGroup: false,
        subHeaders: [],
        templates: [permissionsListTemplate[3]],
      },
      studioFind?.taxRegion !== "ES"
        ? {
            header: <FormattedMessage id="settings.userPermissions.canDoTitle" />,
            isMultipleGroup: false,
            subHeaders: [],
            templates: [permissionsListTemplate[4]],
          }
        : null,
    ];

    collapsePanels = collapsePanelsStructure?.map((panel, index) => {
      if (isManagerUser && index === 1) {
        return null;
      }

      if (!panel?.templates) {
        return null;
      }

      const multipleContent = (
        <>
          <h4 className="permissionsSubTitle">{user?.profile?.language === "es-ES" ? "En su página de inicio" : panel.subHeaders?.[0]}</h4>
          {panel.templates?.[0]}
          <h4 className="permissionsSubTitle">{user?.profile?.language === "es-ES" ? "En su menú" : panel.subHeaders?.[1]}</h4>
          {panel.templates?.[1]}
          <h4 className="permissionsSubTitle">{user?.profile?.language === "es-ES" ? "En sus documentos" : panel.subHeaders?.[2]}</h4>
          {panel.templates?.[2]}
        </>
      );

      return (
        <Panel header={panel.header} key={index} className="settings-header-collapse-custom-panel header-collapse-custom-panel-custom-panel">
          {panel.isMultipleGroup ? multipleContent : panel.templates}
        </Panel>
      );
    });
  }

  return (
    <>
      {isLoading ? (
        <div className="loaderContainer">
          <FontAwesomeIcon icon={["far", "circle-notch"]} spin style={{ color: "rgb(70, 165, 219)", fontSize: "50px" }} />
        </div>
      ) : (
        <>
          {isManagerUser && (
            <h4 className="userManagerTitle">
              <b>{userCompleteName}</b> su <b>{ragioneSocialeAzienda}</b> <FormattedMessage id="settings.userPermissions.userManagerTitle" />{" "}
            </h4>
          )}
          <Collapse bordered={false} className="userSettingsPanels">
            {collapsePanels}
          </Collapse>
          <UserSettingsButtons changeInSettings={changeInSettings} saveUserPermissions={saveUserPermissions} resetUserPermissions={resetUserPermissions} />
          <BusinessPerformanceModal
            currentPermissions={currentPermissions}
            settings={settings}
            changeToggle={changeToggle}
            isBusinessPerformanceModalOpen={isBusinessPerformanceModalOpen}
            onCloseBusinessPerformanceModal={onCloseBusinessPerformanceModal}
            saveBusinessPerformancePermissions={saveUserPermissions}
            changeInSettings={changeInSettings}
            resetAll={resetUserPermissions}
            isUser={true}
            userCompleteName={userCompleteName}
            companyName={ragioneSocialeAzienda}
          />
        </>
      )}
    </>
  );
};

export default UserSettings;
